import { render, staticRenderFns } from "./siteDisposal.vue?vue&type=template&id=04c48e98&scoped=true&"
import script from "./siteDisposal.vue?vue&type=script&lang=js&"
export * from "./siteDisposal.vue?vue&type=script&lang=js&"
import style0 from "./siteDisposal.vue?vue&type=style&index=0&id=04c48e98&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c48e98",
  null
  
)

export default component.exports